export const GET_THERMOBOXES = 'thermoboxes/GET_THERMOBOXES';
export const getThermoboxesAction = payload => ({
	type: GET_THERMOBOXES,
	payload,
});

export const SET_THERMOBOXES = 'thermoboxes/SET_THERMOBOXES';
export const setThermoboxesAction = payload => ({
	type: SET_THERMOBOXES,
	payload,
});

export const SET_IS_THERMOBOXES_LOADING = 'thermoboxes/SET_IS_THERMOBOXES_LOADING';
export const setIsThermoboxesLoadingAction = payload => ({
	type: SET_IS_THERMOBOXES_LOADING,
	payload,
});

export const SET_PAGINATION = 'thermoboxes/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'thermoboxes/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
